// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mw4U","delete":"styles_delete__2u7xA","update":"styles_update__EPI3-","add":"styles_add__1z74c"};